import React, { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import type { ButtonProps } from 'src/common/components/ButtonDS22';
import styles from './ButtonGroup.module.scss';

export type ButtonGroupProps = {
  children: React.ReactNode;
  /** When buttons wrap from row into a column, which button should be on top? */
  topButtonWhenStacked?: 'left' | 'right';
  /**
   * Space buttons apart from a specific breakpoint (justify-content: space-between)
   *
   * IMPORTANT: ButtonDS22 children should match this value on their `fitWidth` prop.
  */
  apartFrom?: ButtonProps['fitWidth'];
  width?: 'full' | 'auto';
};

const ButtonGroup: FC<ButtonGroupProps> = ({
  topButtonWhenStacked = 'right',
  apartFrom,
  children,
  width = 'full',
}) => (
  <div className={getClassNames(styles, 'root', classNames(width, {
    stackLeftOnTop: topButtonWhenStacked === 'left',
    stackRightOnTop: topButtonWhenStacked === 'right',
    apartFromM: apartFrom === 'm',
    apartFromL: apartFrom === 'l',
  }))}
  >
    {children}
  </div>
);

export default ButtonGroup;
